//uso import {convertirFecha} from './utiles_objetos';

//convertir fechas a local
const FECHA_DEFAULT = new Date(2023, 0, 1);

export function convertirFechaFirebase(fecha) {


  // Fecha por defecto: 1 de enero de 2023
  const FECHA_DEFAULT = new Date(2023, 0, 1); // Mes 0 = enero

  if (!fecha) {
    return FECHA_DEFAULT;
  }

  try {
    // Si es un objeto Firestore Timestamp
    if (fecha._seconds !== undefined && fecha._nanoseconds !== undefined) {
      const resultado = new Date(fecha._seconds * 1000);
      
      if (isNaN(resultado.getTime())) {
        return FECHA_DEFAULT;
      }
      
      return resultado;
    }

    // Si es una cadena de texto
    if (typeof fecha === 'string') {
      
      // Caso específico: formato con microsegundos como "2025-06-18T17:12:38.797Z"
      // O formato extendido como "2025-06-18T17:12:38.797234Z"
      if (fecha.includes('T') && (fecha.includes('Z') || fecha.includes('+'))) {
        
        // Si tiene más de 3 dígitos en microsegundos, los truncamos a milisegundos
        let fechaLimpia = fecha;
        
        // Buscar el patrón de microsegundos (más de 3 dígitos después del punto)
        const microsegundosRegex = /(\.\d{3})\d+([Z\+\-])/;
        if (microsegundosRegex.test(fechaLimpia)) {
          const fechaOriginal = fechaLimpia;
          fechaLimpia = fechaLimpia.replace(microsegundosRegex, '$1$2');
        }
        
        const resultado = new Date(fechaLimpia);
        
        if (!isNaN(resultado.getTime())) {
          return resultado;
        } else {
          return FECHA_DEFAULT;
        }
      }
      
      // Otros formatos de cadena estándar
      const resultado = new Date(fecha);
      
      if (!isNaN(resultado.getTime())) {
        return resultado;
      } else {
        return FECHA_DEFAULT;
      }
    }

    // Si es un número (timestamp en milisegundos o segundos)
    if (typeof fecha === 'number') {
      
      // Validar que el número sea un timestamp válido
      if (fecha <= 0) {
        return FECHA_DEFAULT;
      }
      
      // Si parece ser timestamp en segundos (menos de año 2100)
      if (fecha < 4102444800) {
        const resultado = new Date(fecha * 1000);
        
        if (isNaN(resultado.getTime())) {
          return FECHA_DEFAULT;
        }
        
        return resultado;
      }
      
      // Si parece ser timestamp en milisegundos
      const resultado = new Date(fecha);
      
      if (isNaN(resultado.getTime())) {
        return FECHA_DEFAULT;
      }
      
      return resultado;
    }

    // Si ya es una fecha válida
    if (fecha instanceof Date) {
      if (!isNaN(fecha.getTime())) {
        return fecha;
      } else {
        return FECHA_DEFAULT;
      }
    }

    // Si es un objeto con propiedades de fecha
    if (typeof fecha === 'object') {
      console.log('🗂️ Detectado objeto:', fecha);
      
      // Intenta convertir objetos que tengan propiedades de fecha
      if (fecha.seconds) {
        const resultado = new Date(fecha.seconds * 1000);
        
        if (isNaN(resultado.getTime())) {
          return FECHA_DEFAULT;
        }
        
        return resultado;
      }
      
      if (fecha.toDate && typeof fecha.toDate === 'function') {
        try {
          const resultado = fecha.toDate();
          
          if (resultado instanceof Date && !isNaN(resultado.getTime())) {
            return resultado;
          } else {
            return FECHA_DEFAULT;
          }
        } catch (error) {
          return FECHA_DEFAULT;
        }
      }
    }

    return FECHA_DEFAULT;

  } catch (error) {
    console.error('💥 Error al convertir fecha:', {
      fecha,
      error: error.message,
      stack: error.stack
    });
    
    console.log('🆘 Error capturado: retornando fecha por defecto (2023-01-01)');
    return FECHA_DEFAULT;
  }
}

// Función auxiliar para obtener la fecha por defecto (útil para otros lugares del código)
export function getFechaDefault() {
  return new Date(2023, 0, 1); // 1 de enero de 2023
}

// Función para verificar si una fecha es la fecha por defecto
export function esFechaDefault(fecha) {
  if (!fecha || !(fecha instanceof Date)) return false;
  
  const fechaDefault = getFechaDefault();
  return fecha.getFullYear() === fechaDefault.getFullYear() &&
         fecha.getMonth() === fechaDefault.getMonth() &&
         fecha.getDate() === fechaDefault.getDate();
}

//funciones updateJson para conversion
export function conversionStringJson(value,defaultValue) {
  if (value === null || value === undefined) return defaultValue;
    if (typeof value === 'string') return value;
    if (typeof value === 'object') {
      try {
        return JSON.stringify(value);
      } catch (e) {
        console.warn('Error al convertir objeto a string:', e);
        return defaultValue;
      }
    }
    return String(value);
}

export function conversionNumberJson(value,defaultValue){
    if (value === null || value === undefined) return defaultValue;
    if (typeof value === 'number' && !isNaN(value)) return value;
    if (typeof value === 'string') {
      const parsed = parseFloat(value);
      return isNaN(parsed) ? defaultValue : parsed;
    }
    return defaultValue;
}

export function conversionFechaJson(value,defaultValue){
  if (value === null || value === undefined) return defaultValue;
    if (value instanceof Date) return value;
    
    try {
      // Manejo de fechas ISO 8601 como "2025-06-21T07:31:00.000Z"
      if (typeof value === 'string') {
        const date = new Date(value);
        return isNaN(date.getTime()) ? defaultValue : date;
      }
      
      // Manejo de timestamps de Firebase
      if (typeof value === 'object' && value.toDate) {
        return value.toDate();
      }
      
      // Intentar convertir directamente
      const date = new Date(value);
      return isNaN(date.getTime()) ? defaultValue : date;
    } catch (e) {
      console.warn('Error al convertir fecha:', e);
      return defaultValue;
    }
}

export function conversionBooleanoJson(value, defaultValue) {
  console.log(`🔍 conversionBooleanoJson - Input: value=${value} (tipo: ${typeof value}), defaultValue=${defaultValue}`);
  
  if (value === null || value === undefined) {
    console.log(`❌ conversionBooleanoJson - Valor null/undefined, retornando defaultValue: ${defaultValue}`);
    return defaultValue;
  }
  
  if (typeof value === 'boolean') {
    console.log(`✅ conversionBooleanoJson - Es boolean válido, retornando: ${value}`);
    return value;
  }
  
  if (typeof value === 'string') {
    const lowerValue = value.toLowerCase().trim();
    const result = lowerValue === 'true' || lowerValue === '1' || lowerValue === 'yes';
    console.log(`🔧 conversionBooleanoJson - String convertido: "${value}" → ${result}`);
    return result;
  }
  
  if (typeof value === 'number') {
    const result = value !== 0;
    console.log(`🔧 conversionBooleanoJson - Number convertido: ${value} → ${result}`);
    return result;
  }
  
  console.log(`⚠️ conversionBooleanoJson - Tipo no manejado (${typeof value}), usando Boolean(): ${Boolean(value)}`);
  return Boolean(value);
}

//convertir parrseo de contenido
export const parsearContenido = (content) => {
  console.log("pasrssear contenido",content);
  // Si ya es un objeto, lo devolvemos directamente.
  if (typeof content === 'object' && content !== null) {
    return content;
  }

  // Si no es un string, no podemos parsearlo.
  if (typeof content !== 'string') {
    return { body: '[Contenido no disponible]' };
  }

  try {
    // Intenta convertir el string a un objeto.
    return JSON.parse(content);
  } catch (error) {
    console.error("Error al parsear el contenido JSON:", content, error);
    // Si falla, devuelve un objeto con un mensaje de error.
    return { body: '[Mensaje con formato inválido]' };
  }
};

//convertir fecha para validar
export const esFechaEntregaValida = (fecha) =>{
  // 1. Verifica que sea un objeto Date válido
    if (!fecha || !(fecha instanceof Date)) {
        return false;
    }

    // 2. Verifica que NO sea la fecha por defecto
    if (fecha.getFullYear() === 2023 && 
        fecha.getMonth() === 0 && // 0 = Enero
        fecha.getDate() === 1) {
        return false; // Es la fecha por defecto, no cuenta
    }

    // Si pasó ambas pruebas, es una entrega válida
    return true;
}

//convertir a contenido quill
export function parsearParaContenidoEnriquecido(dato) {
  // 1. Si es null, undefined o vacío, devolvemos un Delta vacío de Quill
  if (!dato) {
    return []; // Array vacío es un contenido válido para Quill
  }

  // 2. Si ya es un Array (es decir, ya es el formato correcto Quill Delta)
  if (Array.isArray(dato)) {
    return dato;
  }

  // 3. Si es un objeto, revisamos si tiene la propiedad 'contenidoEnriquecido'
  // (Caso: pasaste el objeto completo del servicio en lugar de solo el texto)
  if (typeof dato === 'object' && dato !== null) {
    if (dato.contenidoEnriquecido && Array.isArray(dato.contenidoEnriquecido)) {
      return dato.contenidoEnriquecido;
    }
    // Si es un objeto genérico tipo {ops: [...]}, lo devolvemos
    if (dato.ops) {
      return dato.ops;
    }
    // Si es otro tipo de objeto, probablemente no es contenido válido, devolvemos array vacío
    return []; 
  }

  // 4. Si es un String, intentamos parsearlo (puede ser un JSON stringificado)
  if (typeof dato === 'string') {
    try {
      const parsed = JSON.parse(dato);
      
      // Si al parsear obtenemos un Array, ¡Bingo! Es un Delta guardado como string
      if (Array.isArray(parsed)) {
        return parsed;
      }
      
      // Si al parsear obtenemos el objeto con ops
      if (parsed.ops && Array.isArray(parsed.ops)) {
        return parsed.ops;
      }

    } catch (e) {
      // Fallo silencioso, significa que es Texto Plano simple
    }

    // 5. FALLBACK: Texto Plano (Legacy)
    // Convertimos el texto simple "Hola" en formato Quill: [{"insert": "Hola\n"}]
    return [
      { insert: dato + "\n" } 
    ];
  }

  return [];
}